<side-sheet
    #editHierarchy
    (mainSaveClick)="saveNewHieararchyToDatabase($event)"
    (mainCancelClick)="cancelAllChanges($event)"
    (sideSheetSaveClick)="addChangesToTiles($event)"
    (sideSheetCancelClick)="cancelSidesheetChanges($event)"
    (sideSheetDeleteClick)="deleteSelectedLevel($event)"
    [isSideSheetSaveBtnDisabled]="isSideSheetSaveBtnDisabled"
    [isMainSaveBtnDisabled]="isMainSaveBtnDisabled"
    [isDeleteButtonHidden]="isDeleteButtonHidden"
    [sideSheetTitle]="sideSheetTitle"
    [isMainButtonSetHidden]="isMainButtonSetHidden"
    [isEditDialogClose]="isEditHierarchyDialogClose"
>
    <div class="hierarchy-main-controller">
        <div class="hierarchy-main-container">
            <div *ngFor="let tile of corporateHierarchy" class="hierarchy-tile-area">
                <div
                    *ngIf="tile.tileData.isActive"
                    id="add-new-dialog-{{ tile.roleOrder }}"
                    [hidden]="true"
                >
                    <tile-connector
                        *ngIf="!tile.isTopLevel"
                        [isAllBtnHidden]="tile.hideCancelButton"
                        [addNew]="false"
                        (addNewOrCancel)="cancelButton($event, tile)"
                    >
                    </tile-connector>
                    <hierarchy-tile
                        [hideEditIcon]="true"
                        [hideTitleIcon]="true"
                        [tileName]="'New Level'"
                        [fontIcon]="''"
                        [fontSet]="''"
                        [activeShadow]="'active-shadow'"
                        [description]="''"
                        (editClicked)="openEditSidesheet($event, tile)"
                    >
                    </hierarchy-tile>
                </div>
                <div *ngIf="tile.tileData.isActive">
                    <tile-connector
                        *ngIf="!tile.isTopLevel"
                        [isAllBtnHidden]="tile.hideAddButton"
                        [addNew]="true"
                        (addNewOrCancel)="addNewButton($event, tile)"
                    >
                    </tile-connector>
                    <hierarchy-tile
                        [hideEditIcon]="tile.hideEditIcon"
                        [hideTitleIcon]="tile.hideTitleIcon"
                        [tileName]="tile.tileName"
                        [fontIcon]="tile.fontIcon"
                        [fontSet]="tile.fontSet"
                        [activeShadow]="tile.activeShadow"
                        [description]="tile.tileData.description"
                        (editClicked)="openEditSidesheet($event, tile)"
                    >
                    </hierarchy-tile>
                </div>
            </div>
        </div>
    </div>
    <div class="hierarchy-edit-controller">
        <div>Name of Level</div>
        <div>
            <mat-form-field appearance="outline">
                <input
                    matInput
                    [(ngModel)]="hierarchyData.roleName"
                    name="hierarchyData.roleName"
                    (ngModelChange)="dataChanged()"
                    maxlength="100"
                    minlength="3"
                />
            </mat-form-field>
            <div *ngIf="isRoleNameInUse" class="errors">
                *{{ hierarchyData.roleName }} is already in use.
            </div>
            <div
                *ngIf="!hierarchyData.roleName || hierarchyData.roleName.length < 3"
                class="errors"
            >
                *Required (at least 3 characters)
            </div>
        </div>

        <div class="input-title">Description</div>
        <div>
            <mat-form-field appearance="outline">
                <input
                    matInput
                    [(ngModel)]="hierarchyData.description"
                    name="hierarchyData.description"
                    (ngModelChange)="dataChanged()"
                    maxlength="50"
                />
            </mat-form-field>
        </div>
    </div>
</side-sheet>
